import api from '/src/api.js';
import { useDeviceStore } from '/src/store/stores/useDeviceStore.js';

function extractDeviceData () {
	const { companyIds, officeId, groupId, departmentId } = useDeviceStore();
	return {
		companyIds,
		officeIds: companyIds?.length === 1 ? [officeId] : [],
		groupIds: groupId ? [groupId] : [],
		departmentIds: departmentId ? [departmentId] : [],
	};
}

export function getEmployees (data, options = {}) {
	const { companyIds, officeIds } = useDeviceStore();
	// return api.post('/employees-by-company-ids', data, {
	return api.post('/employees-by-offices-and-groups', data, {
		...options,
		...extractDeviceData(),
		withMeta: true,
	});
}

export async function getEmployee (data, options = {}) {
	const employees = await api.post(`/employees-by-company-ids?employeeIds[in]=${data.employeeId}`, data, {
		...options,
		...extractDeviceData(),
		withMeta: false,
	});

	return employees.length ? employees[0] : null;
}

export function getEmployeeByCredentials (form, options) {
	return form.post(`devices/${form.deviceId}/employee`, {
		...options,
	});
}
